'use client';
import { motion } from 'motion/react';
import { createContext, useContext, useState } from 'react';

const GameHubConnectionContext = createContext(null);

export const GameHubConnectionProvider = ({ children }) => {
  const [audioPlayerIsOpen, setAudioPlayerIsOpen] = useState(true);
  const [shownButton, setShownButton] = useState('none');

  const hidePlayerElement = () => {
    const audioPlayer = document.getElementById('audioActive');
    if (audioPlayer) {
      audioPlayer.style.display = 'none';
    }
    const fakeAudioPlayer = document.getElementById('fake-audio-layer');

    if (fakeAudioPlayer) {
      fakeAudioPlayer.style.display = 'block';
    }

    setShownButton('sound');
  };

  const changeSoundBehaviour = () => {
    const newSoundState = shownButton === 'sound' ? 'nosound' : 'sound';
    setShownButton(newSoundState);
    window.audioConfiguration = newSoundState === 'sound' ? 'F' : 'off';
  };

  const playLastSound = () => {
    const audioPlayer = document.getElementById('audioActive');
    if (audioPlayer) {
      audioPlayer.play();
    }
  };

  return (
    <GameHubConnectionContext.Provider value={null}>
      <div
        id={'audio-player-fixed'}
        style={{ display: 'none' }}
        className="row mb-2 position-fixed fixed-top rounded rounded-bottom-3 bg-light audio-player-fixed"
      >
        <div className="col-12 text-center text-md-start d-flex align-items-center justify-content-between fw-bold pe-0">
          <p className={'my-0'}>
            &nbsp; Son du boulier
            <br />
          </p>
          <div className="">
            <motion.button
              className="btn btn-light btn-sm"
              animate={{ rotate: audioPlayerIsOpen ? 0 : 180 }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={() => {
                setAudioPlayerIsOpen((old) => !old);
              }}
            >
              &#8963;
            </motion.button>
          </div>
        </div>
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: audioPlayerIsOpen ? 1 : 0, height: audioPlayerIsOpen ? 'auto' : 0 }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="col-12 overflow-x-auto customized-scrollbar">
            <div className="d-flex h-100 align-items-center">
              <audio 
                controls 
                id="audioActive" 
                onEnded={hidePlayerElement}
              >
                <source src="/Audio/F/Audioactive.mp3?v2" type="audio/mp3" />
              </audio>
            </div>
          </div>
          <div className="col-12" style={{ display: shownButton == 'none' ? 'block' : 'none' }}>
            <em className={'ps-4'} style={{ fontSize: '0.65rem' }}>
              Faites jouer pour activer le son
            </em>
          </div>
          <div id="fake-audio-layer" style={{ display: 'none' }}>
            <div className="px-2">
              {/* <small className="text-muted fs-10 ">
              Cliquez deux fois pour désactiver le son et une fois pour réactiver.
            </small> */}
            </div>
            <div className="col-12 border-1 border-black">
              <center>
                <button className={'btn btn-light btn-sm'} onClick={() => playLastSound()} title="Rejouer">
                  🔃
                </button>
                <button
                  className={'btn btn-light btn-sm'}
                  onClick={() => changeSoundBehaviour()}
                  title={shownButton === 'sound' ? 'Jouer les sons' : 'Ne pas jouer les sons'}
                >
                  <i>{shownButton === 'sound' ? '🔊' : '🔇'}</i>
                </button>
              </center>
            </div>
          </div>
        </motion.div>
      </div>
      {children}
    </GameHubConnectionContext.Provider>
  );
};

export const useGameHubConnection = () => useContext(GameHubConnectionContext);
